"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var keys_1 = require("../keys");
function default_1() {
    return {
        toLitiumMediaUrl: (0, vue_1.inject)(keys_1.toLitiumMediaUrlKey, function () { return ''; }),
    };
}
exports.default = default_1;
//# sourceMappingURL=withLitium.js.map